import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./layout/DashboardLayout";
import Login from "./pages/Login";
import OTP from "./pages/OTP";
import Dashboard from "./pages/Dashboard";
import MessageSearch from "./pages/Search";
import ProtectedRoute from "./components/ProtectedRoute";
import RootRedirect from "./components/RootRedirect";
import LogsPage from "./pages/Logs";
import ResetPassword from "./pages/ResetPassword"; // Add this import

function App() {
	return (
		<Routes>
			{/* Root path redirect */}
			<Route path='/' element={<RootRedirect />} />

			{/* Public Routes */}
			<Route path='/login' element={<Login />} />
			<Route path='/otp' element={<OTP />} />
			<Route path='/otp' element={<OTP />} />
			<Route path='/reset-password' element={<ResetPassword />} /> {/* Add this route */}

			{/* Protected Routes */}
			<Route
				path='/'
				element={
					<ProtectedRoute>
						<DashboardLayout />
					</ProtectedRoute>
				}
			>
				<Route path='dashboard' element={<Dashboard />} />
				<Route path='messages' element={<MessageSearch />} />
				<Route path='logs' element={<LogsPage />} />
			</Route>
		</Routes>
	);
}

export default App;